// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SiderBottomLinks_wrapper__2fz_I","menu":"SiderBottomLinks_menu__2LlEf","item":"SiderBottomLinks_item__3gGw5"};